import { useState, useEffect, useMemo, useCallback } from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { api } from '@/services/api-class';
import { App } from '@/services/app-compat';

export function CaseReportManagementScreen() {
    const { theme } = useTheme();
    const [isNotifyingSupervisorsOnPendingApproval, setIsNotifying] = useState<boolean | null>(null);

    const settingsLoaded = useMemo(() => isNotifyingSupervisorsOnPendingApproval !== null, [isNotifyingSupervisorsOnPendingApproval]);

    useEffect(() => {
        api.getCaseReportSettings(
            (result: any) => { setIsNotifying(result.isNotifyingSupervisorsOnPendingApproval); },
            () => { App.showPopupNotification("Error getting settings.", "error"); }
        );
    }, []);

    const handleUpdate = useCallback(() => {
        api.updateCaseReportSettings(
            { isNotifyingSupervisorsOnPendingApproval },
            () => { App.showPopupNotification("Case Report settings saved.", "success"); },
            () => { App.showPopupNotification("Error updating settings.", "error"); }
        );
    }, [isNotifyingSupervisorsOnPendingApproval]);

    return (
        <div className={theme}>
            <div className="kst-page-container">
                <div className="kst-layout kst-layout--no-sidebar">
                    <div className="kst-main-content">
                        <div className="kst-page">
                            <div className="kst-page-header">
                                <h3 className="kst-page-title">Case Report Settings</h3>
                                <p className="kst-page-description">
                                    Configure general settings for Case Reports.
                                </p>
                            </div>

                            {settingsLoaded ? (
                                <div className="kst-settings-form">
                                    <div className="kst-checkbox-group">
                                        <input
                                            type="checkbox"
                                            id="chkIsNotifyingSupervisorsOnPendingApproval"
                                            className="kstc-checkbox"
                                            checked={isNotifyingSupervisorsOnPendingApproval || false}
                                            onChange={(e) => setIsNotifying(e.target.checked)}
                                        />
                                        <label className="kstc-checkbox-label" htmlFor="chkIsNotifyingSupervisorsOnPendingApproval">
                                            Notify supervisors on pending approval
                                        </label>
                                    </div>
                                    <div className="kst-settings-actions">
                                        <button type="button" className="kstc-btn kstc-btn--primary" onClick={handleUpdate}>
                                            Save
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="kst-loading"></div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CaseReportManagementScreen;

